<template>
  <div class="home">
    <HeroScene />
    <ProjectGrid />
  </div>
</template>

<script>
import HeroScene from '@/components/HeroScene.vue'
import ProjectGrid from '@/components/ProjectGrid.vue'

export default {
  name: 'Home',
  components: {
    HeroScene,
    ProjectGrid
  }
}
</script>